<template>
    <div class="p-20" style="width: calc(100% - 315px)">
        <div class="title bg-default px-20 pt-16">
            工会年度累计报表
            <el-form :model="form" size="small" label-width="68px" class="mt-20">
                <idc-form-item :form="form" :config="formConfig" class="basicReport">
                    <div class="flex-x-end">
                        <el-button :disabled="loading" @click="search" type="primary">
                            查询
                        </el-button>
                    </div>
                </idc-form-item>
            </el-form>
        </div>
        <div >
            <div class="mt-20 bg-default p-20">
                <div class="title report-title">
                    {{ tableList[0].name }}
                </div>
                <idc-table element-loading-text="拼命加载中" v-loading="loading" :data="tableList[0].data" :column="tableList[0].column" :checkbox="false" class="mt-20" />
            </div>
            <div class="mt-20 bg-default col-14 p-20">
                <div class="title report-title">
                    {{ tableList[1].name }}
                </div>
                <idc-table element-loading-text="拼命加载中" v-loading="loading" :data="tableList[1].data" :column="tableList[1].column" :checkbox="false" class="mt-20" />
            </div>
        </div>
    </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
    data() {
        return {
            loading:true,
            form: {},
            formConfig: [
                {
                    itemType: 'date-picker',
                    prop: 'time',
                    label: '日期选择',
                    'value-format': 'yyyy-MM-dd',
                    pickerOptions: {
                        disabledDate(time) {
                            return  time.getTime() >= new Date(new Date().setHours(0, 0, 0, 0));
                        }
                    }
                }
            ],
            tableList: [
                {
                    name: '年度累计交易情况',
                    column: [
                        { labourOrderTypeStr: '工会订单类型' },
                        { orderTotalNum: '总订单（笔）' },
                        { orderTotalAmount: '总金额（万元）' },
                        { payOrderTotalNum: '已支付订单（笔）' },
                        { payOrderTotalAmount: '已支付金额（万元）' },
                        { waitPayOrderTotalNum: '待支付订单（笔）' },
                        { waitPayOrderTotalAmount: '待支付金额（万元）' }
                    ],
                    data: []
                },
                {
                    name: '年累计兑换码使用情况',
                    column: [{ yearGrantCouponsNum: '年累计发券量（张）' }, { dayGrantCouponsNum: '当日发券量（张）' }, { yearExchangeCouponsNum: '年累计兑换数量（张）' },
                        { dayExchangeCouponsNum: '当日新兑换量（张）' }, { dayWaitDeliveryOrderRedeemNum: '当日待发货订单数' }],
                    data: []
                }
            ]
        };
    },
    created() {
        const yesterday = new Date(new Date().getTime() - 3600 * 24 * 1000);
        this.form.time = yesterday.getFullYear() + '-' + String(yesterday.getMonth() + 1).padStart(2, 0) + '-' + String(yesterday.getDate()).padStart(2, 0);
        this.form = JSON.parse(JSON.stringify(this.form));
        this.search();
    },
    methods: {
        getLabourOrderTypeStr(arr){
            arr.forEach(function (item){
                if(item.labourOrderType === 2){
                    item.labourOrderTypeStr = "统一送货（立即送货）";
                }else if(item.labourOrderType === 3){
                    item.labourOrderTypeStr = "统一送货（指定时间送货）";
                }else if(item.labourOrderType === 4){
                    item.labourOrderTypeStr = "兑换码自主兑换";
                }else if(item.labourOrderType === 99){
                    item.labourOrderTypeStr = "合计";
                }
            });
        },
        search() {
            if(!this.form.time){
                this.$message.error("请选择查询日期");
                return;
            }
            this.loading = true;
            this.$http.post('/basic/labourBusiness/year/report', { queryTime: this.form.time }).then(res => {
                this.loading = false;
                const data = res.data || {labourOrderYearReportDtos:[],labourBusinessYearTocDto:{}};
                this.getLabourOrderTypeStr(data.labourOrderYearReportDtos);
                this.tableList[0].data = data.labourOrderYearReportDtos;
                this.tableList[1].data = [data.labourBusinessYearTocDto];
                if(!res.data){
                    this.$message.error(res.message);
                }
            });
        }
    }
};
</script>
<style scoped lang="css">
.report-title {
    margin-bottom: 20px;
}
</style>
